import { Group } from '@/components/_common';
import SpaceForButton from '@/components/_common/SpaceForButtons';
import useCopyToClipboard from '@/hooks/useCopyToClipboard';
import { Collapse, Typography, Button } from 'antd';
import { CheckSquare, Copy, Download } from 'react-feather';
import { ImportJsonExample } from './ImportJsonExample';

const { Panel } = Collapse;
const { Paragraph, Title, Text } = Typography;

export default function ImportHelpJSON() {
  const { copyToClipboard, isCopied } = useCopyToClipboard();

  const jsonExample = JSON.stringify(ImportJsonExample, null, 2);

  const requiredFields = [
    {
      label: 'CNPJ da empresa',
      value: 'companyCNPJ',
    },
    {
      label: 'Placa do veículo',
      value: 'licensePlate',
    },
    {
      label: 'Nome ou número do documento do cliente',
      value: 'customer.name ou customer.documentNumber',
    },
    {
      label: 'CNPJ da seguradora',
      value: 'insurer.cnpj',
    },
  ];

  const handleDownload = () => {
    const blob = new Blob([jsonExample], { type: 'application/json' });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = 'exemplo.json';
    link.click();
  };

  return (
    <Collapse style={{ marginTop: 16 }} defaultActiveKey={['1']}>
      <Panel header="Como utilizar o formato JSON" key="1">
        <Paragraph>
          Para importar o orçamento no formato JSON, utilize a seguinte
          estrutura:
        </Paragraph>

        <Paragraph>
          O modelo JSON deve conter informações como CNPJ da empresa, valor da
          franquia, valor total de peças, valor total de serviços, e detalhes do
          cliente e da seguradora.
        </Paragraph>

        <Title level={5}>Campos obrigatórios:</Title>

        <ul>
          {requiredFields.map((field, index) => (
            <li key={index}>
              <Text strong>{field.label}:</Text> {field.value}
            </li>
          ))}
        </ul>

        <Title level={5}>Exemplo de modelo JSON:</Title>

        <Paragraph className="scroll">
          <pre style={{ maxHeight: 200 }}>{jsonExample}</pre>
        </Paragraph>

        <SpaceForButton justifyContent="center">
          <Button
            type="primary"
            block
            onClick={() =>
              copyToClipboard(
                jsonExample,
                'Modelo JSON copiado com sucesso!',
                'Não foi possível copiar o modelo JSON.',
              )
            }
            disabled={isCopied}
          >
            <Group position="center">
              {isCopied ? <CheckSquare size={16} /> : <Copy size={16} />}
              {isCopied ? 'Copiado!' : 'Copiar JSON'}
            </Group>
          </Button>

          <Button block type="default" onClick={handleDownload}>
            <Group position="center">
              <Download size={16} />
              Baixar JSON
            </Group>
          </Button>
        </SpaceForButton>
      </Panel>
    </Collapse>
  );
}
